/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class ApplyMaterials extends Sv {
    constructor() {
        super();
        this.baseUrl += '/applyMaterials';
    }

    data({ applyMaterialsCatId, applyMaterialsName, applyMaterialsType, currentPage, pageSize } = {}) {
        return super.get('/data', {
            applyMaterialsCatId,
            applyMaterialsName,
            applyMaterialsType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { applyMaterialsTemplate } = json.data.data;
            if (!applyMaterialsTemplate) {
                json.data.data.applyMaterialsTemplate = [];
            } else {
                json.data.data.applyMaterialsTemplate = applyMaterialsTemplate.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { paperMaterialsTemplate } = json.data.data;
            if (!paperMaterialsTemplate) {
                json.data.data.paperMaterialsTemplate = [];
            } else {
                json.data.data.paperMaterialsTemplate = paperMaterialsTemplate.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { instructions } = json.data.data;
            if (!instructions) {
                json.data.data.instructions = [];
            } else {
                json.data.data.instructions = instructions.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        applyMaterialsCatId,
        applyMaterialsName,
        applyMaterialsType,
        expireDay,
        expireRemindDay,
        reviewRemindDay,
        applyMaterialsTemplate,
        submissionMode,
        paperMaterialsTemplate,
        instructions,
        applyMaterialsCode,
        isRelationCert,
    } = {}) {
        const applyMaterialsTemplateStr = applyMaterialsTemplate
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const paperMaterialsTemplateStr = paperMaterialsTemplate
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const instructionsStr = instructions
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            applyMaterialsCatId,
            applyMaterialsName,
            applyMaterialsType,
            expireDay,
            expireRemindDay,
            reviewRemindDay,
            applyMaterialsTemplate: applyMaterialsTemplateStr,
            paperMaterialsTemplate: paperMaterialsTemplateStr,
            instructions: instructionsStr,
            submissionMode,
            applyMaterialsCode,
            isRelationCert,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    validatorApplyMaterialsName({ id, applyMaterialsName } = {}) {
        return super.get('/validatorApplyMaterialsName', {
            id,
            applyMaterialsName,
        });
    }
}

export default new ApplyMaterials();
export { ApplyMaterials };
